import ReactMarkdown from 'react-markdown'

import styles from './additional-content.module.scss'

export const SearchAdditionalPageContent = ({ pageContent }) => {
  if (!!pageContent && !!pageContent.additionalData) {
    return (
      <div className={styles.container}>
        <div className={styles['inner-container']}>
          <div className={styles.title}>
            <h2>{pageContent.breadcrumbLabel1} Ranges</h2>
          </div>
          <section className={styles.section}>
            <ReactMarkdown
              disallowedElements={['p']}
              unwrapDisallowed>
              {pageContent.additionalData}
            </ReactMarkdown>
          </section>
        </div>
      </div>
    )
  }

  return false
}
